module.exports = __webpack_public_path__ + "static/media/bitbucket.c4293cd2.svg";